import { Col, Row, Space, Typography } from 'antd'
import { FC } from 'react'

import { SVGs } from '../../../../assets'
import { BitazzaText } from '../../../../components'
import { useCountdown } from '../../../../hook'
import { nFormatter } from '../../../../util/formatNumber'
import Styles from './Season.module.scss'

interface Props {
    rewardsHandler: () => void
    info: Season
    rewards?: SeasonReward[]
}

const { Text } = Typography
export const SeasonHeader: FC<Props> = ({ rewardsHandler, info, rewards }) => {
    const { time, timerLabel } = useCountdown(new Date(info.end_date))
    const [days, hours, minutes, seconds] = time

    if (days + hours + minutes + seconds <= 0) {
        return null
    }
    return (
        <Row className={Styles.container} justify="space-around">
            <Col>
                <Space direction={'vertical'} size={0}>
                    <BitazzaText
                        strong
                        content={info.title.toUpperCase()}
                        format="t16"
                        lineHeight={21}
                        letterSpacing={2}
                        color="#fff"
                    />

                    <Text className={Styles.timer}>
                        End in{' '}
                        <BitazzaText
                            strong
                            content={`${days > 0 ? `${days}:` : ''}${
                                hours > 0 ? `${hours}:` : ''
                            }${minutes}:${seconds}`}
                            format="t14"
                            color="#10F48B"
                            lineHeight={18}
                        />{' '}
                        {timerLabel}
                    </Text>
                </Space>
            </Col>
            <Col>
                <Space direction="horizontal" size={10}>
                    <Space direction="vertical" size={0} align="end">
                        <BitazzaText
                            strong
                            content="Current"
                            format="t14"
                            color="#86A1A1"
                            textAlign="right"
                        />
                        <BitazzaText
                            strong
                            content="Prize pool:"
                            format="t14"
                            color="#86A1A1"
                            textAlign="right"
                        />
                    </Space>
                    {rewards &&
                        rewards.length &&
                        rewards.map((rew, index) => (
                            <div key={index} className={Styles.rewardBox}>
                                <img
                                    key={rew.id}
                                    src={rew.icon}
                                    alt="Rewards"
                                    width={28}
                                    height={28}
                                />
                                <div className={Styles.rewardCoins}>
                                    <BitazzaText
                                        bold
                                        content={nFormatter(
                                            rew.total,
                                            1
                                        ).toString()}
                                        format="t14"
                                        color="#fff"
                                    />
                                </div>
                            </div>
                        ))}
                    <img
                        onClick={rewardsHandler}
                        src={SVGs.arrowRight}
                        alt="arrow-right"
                        width={8}
                    />
                </Space>
            </Col>
        </Row>
    )
}
